export const scriptAiPipelineLockKeys = {
  all: ["scriptAiPipelineLock"] as const,
  document: (projectId: string, documentId: string) =>
    [...scriptAiPipelineLockKeys.all, projectId, documentId] as const,
};
